























































































































































































































































































































































































































// vue
import { Component, Prop, Vue } from 'vue-property-decorator';

// components
import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import {
  Event,
  EventContact,
  EventStatus,
  EventVersion,
  JbicLocationDetails
} from '@/store/modules/admin/types/admin.types';
import {
  LocationType,
  VenueFieldData
} from '@/store/modules/admin/types/group-level-attribute.types';
import dayjs from 'dayjs';
import moment, { Moment } from 'moment-timezone';

@Component({
  components: {
    BaseTable,
    SortableTableHeader
  }
})
export default class EventViewComponent extends Vue {
  @Prop({ type: Object })
  readonly currentEvent!: Event;

  @Prop({ type: Object })
  readonly lastReviewedEvent!: EventVersion;

  get eventTitle(): string {
    return this.currentEvent?.title;
  }

  get eventSlogan(): string {
    return this.currentEvent?.slogan;
  }

  get eventStartAt(): string {
    return this.formatDate(this.currentEvent?.startAt);
  }

  get eventEndAt(): string {
    return this.formatDate(this.currentEvent?.endAt);
  }

  get eventTimezone(): string {
    return this.formatTimezone(this.currentEvent?.timezone);
  }

  get eventDescription(): string {
    return this.currentEvent?.description;
  }

  get eventLocation(): string {
    return this.formatLocation(this.currentEvent?.location);
  }

  get locationType(): LocationType {
    return this.currentEvent?.location?.locationType;
  }

  get remoteLink(): string {
    return this.currentEvent?.location?.remoteLink ?? '';
  }

  get eventUrlToEvent(): string {
    return this.currentEvent?.urlToEvent;
  }

  get eventUrlToHost(): string {
    return this.currentEvent?.urlToHost;
  }

  get eventContacts(): EventContact[] {
    return this.currentEvent?.contacts;
  }

  get eventBannerImageUrl(): string {
    return this.currentEvent?.bannerImageUrl;
  }

  get eventTeaserImageUrl(): string {
    return this.currentEvent?.teaserImageUrl;
  }

  get lastReviewedEventTitle(): string {
    return this.lastReviewedEvent?.title;
  }

  get lastReviewedEventSlogan(): string {
    return this.lastReviewedEvent?.slogan;
  }

  get lastReviewedEventStartAt(): string {
    if (!this.lastReviewedEvent) {
      return '';
    }
    const startDate: string = this.formatDate(this.lastReviewedEvent?.startAt);
    if (!startDate) {
      return '';
    }
    return this.formatDate(startDate);
  }

  get lastReviewedEventEndAt(): string {
    if (!this.lastReviewedEvent) {
      return '';
    }
    const endDate: string = this.formatDate(this.lastReviewedEvent?.endAt);
    if (!endDate) {
      return '';
    }
    return this.formatDate(endDate);
  }

  get lastReviewedEventTimezone(): string {
    return this.formatTimezone(this.lastReviewedEvent?.timezone);
  }

  get lastReviewedEventDescription(): string {
    return this.lastReviewedEvent?.description;
  }

  get lastReviewedEventLocation(): string {
    return this.formatLocation(this.lastReviewedEvent?.location);
  }

  get lastReviewedLocationType(): LocationType {
    return this.lastReviewedEvent?.location?.locationType;
  }

  get lastReviewedRemoteLink(): string {
    return this.lastReviewedEvent?.location?.remoteLink ?? '';
  }

  get lastReviewedEventUrlToEvent(): string {
    return this.lastReviewedEvent?.urlToEvent;
  }

  get lastReviewedEventUrlToHost(): string {
    return this.lastReviewedEvent?.urlToHost;
  }

  get lastReviewedEventContacts(): EventContact[] {
    return this.lastReviewedEvent?.contacts;
  }

  get lastReviewedEventBannerImageUrl(): string {
    return this.lastReviewedEvent?.bannerImageUrl;
  }

  get lastReviewedEventTeaserImageUrl(): string {
    return this.lastReviewedEvent?.teaserImageUrl;
  }

  get deniedReason(): string {
    return this.currentEvent?.declinedReason || '';
  }

  isEventStatus(status: EventStatus): boolean {
    return this.currentEvent?.status === status;
  }

  formatDate(date: string): string {
    return dayjs(date).format('D MMMM YYYY, h:mm A');
  }

  formatLocation(location: JbicLocationDetails): string {
    const venueDetails: VenueFieldData | undefined = location?.venueDetails;

    if (!venueDetails) {
      return '';
    }

    let address: string = '';
    address += `${venueDetails.building ? venueDetails.building + ', ' : ''}`;
    address += `${venueDetails.lineOne ? venueDetails.lineOne + ', ' : ''}`;
    address += `${venueDetails.lineTwo ? venueDetails.lineTwo + ', ' : ''}`;
    address += `${venueDetails.postcode ? venueDetails.postcode + ' ' : ''}`;
    address += `${venueDetails.city ? venueDetails.city + ', ' : ''}`;
    address += `${venueDetails.state ? venueDetails.state + ', ' : ''}`;
    address += `${venueDetails.country ?? ''}`;

    if (!address) {
      address = 'Missing address';
    }

    return address;
  }

  formatTimezone(original: string): string {
    if (!original || original.length === 0) {
      return '';
    }
    const now: Moment = moment.tz(original); // Get current time in the timezone
    const offset = now.format('Z'); // Get UTC offset (e.g., +08:00)
    const parts = original.split('/');
    const simplifiedNameRaw = parts[parts.length - 1]; // Get the last segment
    const simplifiedName = simplifiedNameRaw.replace(/_/g, ' '); // Replace underscores with spaces
    return `${simplifiedName} (UTC ${offset})`;
  }

  showPreviousVersion(previousValue: string, currentValue: string): boolean {
    if (!this.isEventStatus(EventStatus.AWAITING_APPROVAL)) {
      // should only show previous version for awaiting approval events
      return false;
    }

    if (!previousValue || previousValue.length === 0) {
      return false;
    }

    if (!currentValue || currentValue.length === 0) {
      return false;
    }

    if (previousValue === currentValue) {
      return false;
    }

    return true;
  }
}
